import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import RequirePermission from "../../../auth/RequirePermission";
import { ADMIN_PERMISSIONS } from "../../../auth/adminPermissions";
import AdminPageLayout from "../../../components/midpoint/admin/layout/AdminPageLayout";
import AdminPageHeader from "../../../components/midpoint/admin/layout/AdminPageHeader";
import AdminStatePanel from "../../../components/midpoint/admin/layout/AdminStatePanel";
import AdminTableContainer from "../../../components/midpoint/admin/layout/AdminTableContainer";
import { dismissTrustReport, fetchTrustSafetyReports } from "../../../services/automapTrustSafetyApi";
import { AdminAutomotiveNav } from "../automotive/AdminAutomotiveNav";
import { CATEGORY_LABELS, SEVERITY_CLASS, SEVERITY_LABELS, TrustSafetyNav, formatDate } from "./trustSafetyShared";

function AdminTrustSafetyReportsPageContent() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    fetchTrustSafetyReports({ sort: "created_desc" })
      .then((data) => setReports(data.reports || []))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  return (
    <AdminPageLayout>
      <AdminAutomotiveNav active="trust-safety" />
      <AdminPageHeader eyebrow="AutoMapa · Confianza" title="Reportes entrantes" navigation={<TrustSafetyNav active="reports" />} />
      <main className="admin-console__main">
        {loading ? <AdminStatePanel variant="empty" message="Cargando…" /> : reports.length === 0 ? (
          <AdminStatePanel variant="empty" message="Sin reportes." />
        ) : (
          <AdminTableContainer>
            <table className="admin-table">
              <thead>
                <tr><th>Tipo</th><th>Categoría</th><th>Listing</th><th>Dealer</th><th>Severidad</th><th>Estado</th><th>Fecha</th><th>Caso</th><th></th></tr>
              </thead>
              <tbody>
                {reports.map((r) => (
                  <tr key={r.id}>
                    <td>{r.reportType}</td>
                    <td>{CATEGORY_LABELS[r.category] || r.category}</td>
                    <td>{r.listingId ? <Link to={`/admin/listings/${r.listingId}`}>{r.listingId.slice(0, 8)}…</Link> : "—"}</td>
                    <td>{r.dealerId ? <Link to={`/admin/dealers/${r.dealerId}`}>{r.dealerId.slice(0, 8)}…</Link> : "—"}</td>
                    <td><span className={`admin-badge ${SEVERITY_CLASS[r.severity]}`}>{SEVERITY_LABELS[r.severity]}</span></td>
                    <td>{r.status}</td>
                    <td>{formatDate(r.createdAt)}</td>
                    <td>{r.caseId ? <Link to={`/admin/trust-safety/cases/${r.caseId}`}>Ver</Link> : "—"}</td>
                    <td><button type="button" onClick={() => dismissTrustReport(r.id).then(load)}>Descartar</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </AdminTableContainer>
        )}
      </main>
    </AdminPageLayout>
  );
}

export default function AdminTrustSafetyReportsPage() {
  return (
    <RequirePermission permission={ADMIN_PERMISSIONS.REAL_ESTATE_SOURCES_VIEW}>
      <AdminTrustSafetyReportsPageContent />
    </RequirePermission>
  );
}
